import { useProfile } from '@roc-digital/ui-lib';

/**
 * Simple hook to detect when the paywall should be active.
 */
export function usePayWall() {
  const profile = useProfile(true);
  return profile?.subscribed ? false : true;
}